import React from 'react'
import EcommerceFilter from './ShowingOurCabinets'
import Header from '../Home/Header'

const Catlog = () => {
  return (
    <>

        <EcommerceFilter />
    </>
  )
}

export default Catlog